import { forwardRef, useEffect, useImperativeHandle, useState, useRef } from 'react'
import { commonObj } from '@/common/common'
import '../css/animation.css'

const Lrc = forwardRef((props, ref) => {
  const baseUrl = commonObj.staticBaseUrl
  const img = 'http://pic.mrzhj.cn/caigou/caigou4.jpg'
  const [cover, setCover] = useState('')
  const [currentSong, setCurrentSong] = useState('')
  const [lrc, setLrc] = useState([])
  const [currentLrcIndex, setCurrentLrcIndex] = useState(-1)
  const lrcWrapRef = useRef()
  useEffect(() => {
    if (!currentSong) return
    console.log('当前歌曲', currentSong)
    init()
  }, [currentSong])
  // 初始化
  const init = () => {
    lrcWrapRef.current.scrollTop = 0
    const suffix = currentSong.songFileName.split('.')[0] + '.lrc'
    fetch(`${baseUrl}/${currentSong.sourceFile}/${suffix}`)
      .then(res => res.text())
      .then(res => {
        // console.log(res.toString())
        const lyrics = formatLrc(res)
        // console.log(lyrics)
        setLrc(lyrics)
      })
  }
  // 歌词格式化
  const formatLrc = val => {
    const lyrics = []
    const lines = val.split('\n')
    // console.log(lines)
    lines.forEach(line => {
      // 支持多种LRC格式: [mm:ss.xx] 或 [mm:ss.xxx] 或 [m:ss.xx] 等
      const match = line.match(/\[(\d{1,2}):(\d{2})[.:](\d{2,3})\](.+)/)
      // 打印match和line,看看正则匹配是否正确
      // console.log('当前行:', line)
      // console.log('匹配结果:', match)
      if (match) {
        const [, minutes, seconds, milliseconds, text] = match
        // 处理2位或3位毫秒
        const ms = milliseconds.length === 2 ? milliseconds : milliseconds.substring(0, 2)
        const timeInSeconds = parseInt(minutes) * 60 + parseFloat(seconds) + parseFloat(`0.${ms}`)
        lyrics.push({ time: timeInSeconds, text })
      }
    })
    return lyrics
  }
  // 更新当前播放时间，用于高亮对应歌词
  const updateCurrentTime = currentTime => {
    if (!lrc.length) return

    // 找到当前时间对应的歌词索引
    let index = -1
    for (let i = 0; i < lrc.length; i++) {
      if (currentTime >= lrc[i].time) {
        index = i
      } else {
        break
      }
    }

    if (index !== currentLrcIndex) {
      setCurrentLrcIndex(index)
      // 自动滚动到当前歌词
      scrollToCurrentLrc(index)
    }
  }

  // 滚动到当前歌词
  const scrollToCurrentLrc = index => {
    if (index >= 0 && lrcWrapRef.current) {
      const lrcItems = lrcWrapRef.current.querySelectorAll('.lrc-item')
      if (lrcItems[index]) {
        lrcItems[index].scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        })
      }
    }
  }

  // 设置封面
  const setCoverUrl = sheet => {
    setCurrentSong(sheet)
    let url = baseUrl + sheet.sourceFile + '/' + sheet.cover
    setCover(url)
    // 重置歌词索引
    setCurrentLrcIndex(-1)
  }

  // 导出父组件可调用的方法
  useImperativeHandle(ref, () => ({
    setCoverUrl,
    updateCurrentTime
  }))

  return (
    <>
      <div className="lrc_box">
        <div className="lrc_top">
          <img
            className={`cover cover-rotating ${props.isPlaying ? 'playing' : ''}`}
            src={cover || img}
            alt=""
          />
          <p className="lrc_song">歌曲：{currentSong.songName || '---'}</p>
          <p>歌手：{currentSong.singer || '---'}</p>
        </div>
        <div className="lrc_wrap personScroll" ref={lrcWrapRef}>
          {lrc.length > 0 ? (
            lrc.map((item, index) => (
              <div key={index} className={`lrc-item ${index === currentLrcIndex ? 'active' : ''}`}>
                {item.text}
              </div>
            ))
          ) : (
            <div className="lrc-item">暂无歌词</div>
          )}
        </div>
      </div>
    </>
  )
})

export default Lrc
